import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { rejectPurchaseResult } from './anabiz-payment-input-reject-purchase.state';

@Component({
  selector: 'asw-anabiz-payment-input-reject-purchase',
  templateUrl: './anabiz-payment-input-reject-purchase.component.html',
  styleUrls: ['./anabiz-payment-input-reject-purchase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnabizPaymentInputRejectPurchaseComponent extends SupportModalBlockComponent {
  reload(): void {}
  init(): void {}
  destroy(): void {}

  public rejectComment: string = '';

  constructor(private _common: CommonLibService) {
    super(_common);
  }

  /**
   * 差戻ボタン押下処理・差戻確定
   */
  rejectPurchase() {
    const reject: rejectPurchaseResult = {
      rejectComment: this.rejectComment,
      isRejected: true,
    };
    this.close(reject);
  }
}
